import { z } from 'zod';
import { notificationIntentSchema } from './notifications.js';
const uuid = z.string().uuid();
const dateTime = z.string().datetime({ offset: true });
export const canteenNotificationKindSchema = z.enum([
    'reservation_changed',
    'reservation_cancelled',
    'menu_or_allergen_changed',
    'receivable_due',
    'settlement_corrected',
    'reservation_reminder',
    'product_or_lot_recalled',
    'urgent_contact',
]);
export const canteenNotificationIntentSchema = notificationIntentSchema.extend({
    source: z.literal('canteen'),
    eventType: z.literal('canteen.notification.intent.v1'),
    kind: canteenNotificationKindSchema,
    context: z.object({
        kind: z.enum([
            'reservation',
            'menu',
            'dietary_profile',
            'settlement',
            'recall',
            'case',
        ]),
        referenceId: uuid,
        effectiveAt: dateTime.nullable().default(null),
    }),
});
export const canteenIntegrationOutboxEventSchema = z.object({
    eventId: uuid,
    schemaVersion: z.literal(1),
    eventType: z.literal('canteen.notification.intent.v1'),
    institutionId: uuid,
    aggregateId: uuid,
    aggregateVersion: z.number().int().positive(),
    occurredAt: dateTime,
    recordedAt: dateTime,
    correlationId: z.string().min(1).max(100),
    causationId: uuid.nullable(),
    payload: canteenNotificationIntentSchema,
});
